import { FC, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import intl from 'react-intl-universal';
import {
  TableOperationHeader,
  AppliedFilters,
  tailwindOverride,
} from '@getsynapse/design-system';
import { useAppThunkDispatch } from 'state/store';
import { selectShouldFetchCapacityFilters } from 'state/Capacities/Filters/filtersSlice';
import { fetchFilterSettingByType } from 'state/Settings/Filters/FiltersSlice';
import { SETTINGS_FILTERS } from 'utils/constants';
import { AppliedFilter } from 'utils/customTypes';
import { useAppliedFilters } from '../../hooks/useAppliedFilters/useAppliedFilters';
import FilterButton from 'Organisms/TableHeaderActionButtons/FilterButton';
import SidePanelFilters from '../Filters/SidePanelFilters';

interface OperationsHeaderProps {
  tableName: string;
}

const OperationsHeader: FC<OperationsHeaderProps> = ({ tableName }) => {
  const dispatch = useAppThunkDispatch();
  const shouldFetchCapacityFilters = useSelector(
    selectShouldFetchCapacityFilters
  );
  const [displaySidePanelFilters, setDisplaySidePanelFilters] =
    useState<boolean>(false);
  const hasFetchedRef = useRef(false);
  const { appliedFilters, handleRemoveFilter, handleClearFilters } =
    useAppliedFilters();

  const toggleSidePanelFilters = () =>
    setDisplaySidePanelFilters((prev) => !prev);

  useEffect(() => {
    if (shouldFetchCapacityFilters && !hasFetchedRef.current) {
      dispatch(fetchFilterSettingByType(SETTINGS_FILTERS.TEAMS_CAPACITY));
      hasFetchedRef.current = true;
    }
  }, [dispatch, shouldFetchCapacityFilters]);

  return (
    <>
      <SidePanelFilters
        isOpen={displaySidePanelFilters}
        onClose={toggleSidePanelFilters}
      />
      <TableOperationHeader
        className={tailwindOverride('border-t-0 border-l-0 border-r-0')}
        hideSearch
        style={{ boxShadow: 'none' }}
        actionButtons={
          <FilterButton
            aria-label={`${tableName}__filter-button`}
            onToggleFilter={toggleSidePanelFilters}
          />
        }
      />
      <AppliedFilters<AppliedFilter>
        filters={appliedFilters}
        onRemoveFilter={handleRemoveFilter}
        onClearAll={handleClearFilters}
        className={tailwindOverride('border-transparent')}
        title={intl.get('FILTER_PANEL.FILTERS_APPLIED')}
        clearAllLabel={intl.get('FILTER_PANEL.CLEAR_ALL')}
      />
    </>
  );
};

export default OperationsHeader;
